<div class="d-flex justify-content-end flex-lg-row align-items-center">
	<div class="d-flex justify-content-between align-items-center mb-4 mb-lg-0">
		<button (click)="first()"
			class="btn btn-nav btn-nav-back">
			<img class="arrow-icon"
				src="assets/images/icon-double-left.svg">
		</button>
		<button (click)="previous()"
			class="btn btn-nav btn-nav-back">
			<img class="arrow-icon"
				src="assets/images/icon-chevron-left.svg">
		</button>
		<nav>
			<ul class="pagination mb-0 d-flex">
				<ng-container *ngIf="!hidePageNumber">
					<ng-container *ngFor="let p of params.pageArray">
						<li *ngIf="showPageNumber(p)"
							[ngClass]="{ active: p === params.page }"
							class="square-number">
							<a (click)="setPage(p)">{{ p + 1 }}</a>
						</li>
					</ng-container>
				</ng-container>
			</ul>
		</nav>
		<button (click)="next()"
			class="btn btn-nav btn-nav-forward">
			<img class="arrow-icon"
				src="assets/images/icon-chevron-right.svg">
		</button>
		<button (click)="last()"
			class="btn btn-nav btn-nav-forward">
			<img class="arrow-icon"
				src="assets/images/icon-double-right.svg">
		</button>
	</div>
	<div class="divider d-none d-lg-block"></div>
	<div class="d-flex justify-content-between align-items-center">
		<div class="pagination-text">Show</div>
		<a href="javascript:void(0)"
			class="dropdown text-muted mx-2"
			appDropdown>
			<span class="me-1">{{ params.limit }}</span>
			<svg-icon [svgClass]="'chevron-down'"
				src="assets/images/icon-chevron-down.svg"></svg-icon>
			<div class="dropdown-menu dropdown-menu-user border-0 shadow-sm px-2 py-3">
				<div *ngFor="let limit of params.limits; let last = last"
					[ngClass]="{ 'mg-2': !last }"
					(click)="changeLimit(limit)"
					class="dropdown-item fw-bold text-primary small px-0 hover">
					{{ limit }}
				</div>
			</div>
		</a>
		<div class="pagination-text">rows</div>
	</div>
</div>
